/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Éléments',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Mis à jour',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Nouveau',
  'company-hub.hub-element-placeholder.extension.sub-heading': "Rien ici pour l'instant. Pensez aux possibilités...",
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Afficher toutes les options',
  'company-hub.hub-element-placeholder.manifest.extension-title': "Espace réservé à l'élément du hub",
};
